import { render } from "./PlayoutSettings.vue?vue&type=template&id=7dcfe586"
import script from "./PlayoutSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7dcfe586"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7dcfe586', __exports__)) {
    api.reload('7dcfe586', __exports__)
  }
  
  module.hot.accept("./PlayoutSettings.vue?vue&type=template&id=7dcfe586", () => {
    api.rerender('7dcfe586', render)
  })

}


export default __exports__